// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Squircle_wrapper__FjVi6","content":"Squircle_content__GRy_F"};